module.exports = __webpack_public_path__ + "static/img/hardware_icon1.81cf335.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oneMachine/hardware_icon1.png
// module id = 8HPP
// module chunks = 0